import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [
  LIST_PROJECT_TECHS,
  LIST_PROJECT_TECHS_SUCCESS,
  LIST_PROJECT_TECHS_FAILURE,
] = createRequestActionTypes('chance/LIST_PROJECT_TECHS');

export const listProjectTechs = createAction(
  LIST_PROJECT_TECHS,
  (id) => (id),
);
const listProjectTechsSaga = createRequestSaga(
  LIST_PROJECT_TECHS,
  techApi.getTechsByProject,
);

const UNLOAD_TECHS = 'chance/UNLOAD_TECHS';
export const unloadTechs = createAction(UNLOAD_TECHS);

export function* projectTechsSaga() {
  yield takeLatest(LIST_PROJECT_TECHS, listProjectTechsSaga);
}

const initialState = {
  techs: null,
  error: null,
};

const projectTechs = handleActions(
  {
    [LIST_PROJECT_TECHS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techs: data.list.map((tech) => ({
        id: tech.reqUuid,
        reqUuid:tech.reqUuid,
        reqNo: tech.reqNo, //요청서 DISPLAY 번호
        reqGrade:tech.reqGrade,
        reqStatus:tech.reqStatus,//요청 / 예정서 / 결과보고(결재전) / 결과보고(결재완료) 
        prjUuid: tech.prjUuid,//프로젝트 Uuid
        workTyp:tech.workTyp,
        custNm:tech.custNm,//고객명
        custEmpNm:tech.custEmpNm,
        workStDt:tech.workStDt,//작업요청시작일
        workEdDt:tech.workEdDt,//작업요청종료일
        workEmpNm:tech.workEmpNm,//작업자
        useYn:tech.useYn,
        crtNm:tech.crtNm,
        crtDt:tech.crtDt,
        cngNm:tech.cngNm,
        cngDt:tech.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECT_TECHS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TECHS]: () => initialState,
  },
  initialState,
);

export default projectTechs;
